<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm px-1'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
        >
          {{ column.label }}
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr (click)="edit.emit(item)" class="cursor-pointer">
      <td class="px-1 py-1 text-sm">{{ item?.category?.title || '---' }}</td>

      <td class="px-1 py-1 text-sm">{{ item?.value | currency }}</td>

      <td class="px-1 py-1 text-sm truncate 2xl:max-w-32 max-w-64">{{ item?.receiver?.name || '---' }}</td>

      <td class="px-1 py-1 text-sm">{{ item?.due_date | date: 'dd/MM/y' }}</td>
    </tr>
  </ng-template>
</p-table>
